import * as React from "react";
import { Flex } from "@rebass/grid";
import { ThunkDispatch } from "../../../types/redux";
import { Alert } from "@blueprintjs/core";
import { getClientDimensionsData } from "src/store/modules/client_dimensions";
import ClientInitialDimensionsEditor from "../Dimensions/ClientInitialDimensionsEditor";
import Loading from "src/components/molecules/Loading";

interface IProps {
  dispatch: ThunkDispatch;
}

interface IState {
  isLoading: boolean;
  saving: boolean;
  showFinalizeDimensionsModal: boolean;
  unsavedDataAlertOpen: boolean;
}

const DimensionsTab: React.FC<IProps & { clientId: number }> = ({
  dispatch,
  clientId,
}) => {
  const [state, setState] = React.useState<IState>({
    isLoading: true,
    saving: false,
    showFinalizeDimensionsModal: false,
    unsavedDataAlertOpen: false,
  });

  React.useEffect(() => {
    // Fetch client dimensions data
    if (clientId) {
      dispatch(getClientDimensionsData(clientId) as any)
        .then(() => setState({ ...state, isLoading: false }))
        .catch((err: any) => {
          console.error("Error fetching client dimensions data:", err);
          setState({ ...state, isLoading: false });
        });
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [clientId]);

  const handleAlertClose = () => {
    const { unsavedDataAlertOpen } = state;
    if (unsavedDataAlertOpen) {
      setState({ ...state, unsavedDataAlertOpen: false });
    }
  };

//   const toggleFinalizeModal = () => {
//     const { showFinalizeDimensionsModal } = state;
//     setState({
//       ...state,
//       showFinalizeDimensionsModal: !showFinalizeDimensionsModal,
//     });
//   };

  return (
    <>
      {state.isLoading ? (
        <Loading />
      ) : (
        <Flex flexDirection="column">
          <Alert isOpen={state.unsavedDataAlertOpen} onClose={handleAlertClose}>
            <h4>Unsaved Data</h4>
            <p>
              Please finish naming any dimensions or dimension instances before
              saving.
            </p>
          </Alert>

          <ClientInitialDimensionsEditor isEditingView={false} clientId={clientId} />
        </Flex>
      )}
      {/* <FinalizeDimensionsModal
        modelInstanceId={modelInstanceId}
        isOpen={state.showFinalizeDimensionsModal}
        onClose={toggleFinalizeModal}
      /> */}
    </>
  );
};

export default DimensionsTab;
